import * as React from 'react';
import { Header5, SolidZhk16, Escrou16, StartSales16 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface IHouseTitleProps {
  name: string;
  gray: boolean;
  isReliable: boolean;
  isEscrow: boolean;
  isSalesStart?: boolean;
}

export function HouseTitle({ name, gray, isReliable, isEscrow, isSalesStart }: IHouseTitleProps) {
  return (
    <div className={styles['title']}>
      <Header5 color={gray ? 'gray40_100' : 'black_100'}>{name}</Header5>
      <div className={styles['labels']}>
        {isReliable && <SolidZhk16 color="primary_100" />}
        {isEscrow && <Escrou16 color="primary_100" />}
        {isSalesStart && <StartSales16 color="error_100" viewBox="-1 -1 18 18" />}
      </div>
    </div>
  );
}
